import {
	OPEN_MENU,
	CLOSE_MENU,
	CLOSE_ALL_MENUS,
	OPEN_FULLSCREEN_MOBILE_SUBNAV,
	CLOSE_FULLSCREEN_MOBILE_SUBNAV
} from './types';

export const openMenu = (menuItemId) => ({
	type: OPEN_MENU,
	menuItemId
});

export const closeMenu = (menuItemId) => ({
	type: CLOSE_MENU,
	menuItemId
});

export const closeAllMenus = () => ({
	type: CLOSE_ALL_MENUS
});

export const openFullscreenMobileSubnav = (menuItemData) => ({
	type: OPEN_FULLSCREEN_MOBILE_SUBNAV,
	payload: menuItemData
});

export const closeFullscreenMobileSubnav = () => ({
	type: CLOSE_FULLSCREEN_MOBILE_SUBNAV
});
